var template = require('./profile_advisor_info.html.slim')
declare var angular

export class ProfileAdvisorInfoController {
  static $inject = ['ProfileAdvisorInfo', 'brand']

  advisorInfo;
  shareInfoOnModalDisplayed = false;
  shareInfoOffModalDisplayed = false;
  brandFullName: string;

  openShareInfoOnModal() {
    this.shareInfoOnModalDisplayed = true;
  }
  closeShareInfoOnModal() {
    this.shareInfoOnModalDisplayed = false;
  }

  openShareInfoOffModal() {
    this.shareInfoOffModalDisplayed = true;
  }
  closeShareInfoOffModal() {
    this.shareInfoOffModalDisplayed = false;
  }

  updateAdvisorInfo(advisorInfo) {
    this.advisorInfo = advisorInfo;
  }

  updateShareInfo(isEnabled) {
    this.ProfileAdvisorInfo.updateShareInfo({ isEnabled: isEnabled }, () => {
      this.advisorInfo.shareInfo = isEnabled;
    });

  }
  constructor(private ProfileAdvisorInfo, private brand) {
    this.brandFullName = this.brand.getBrandFullName();
    this.ProfileAdvisorInfo.get({}).$promise.then((response) => {
        this.updateAdvisorInfo(response);
    });
  }

}

angular.module('wbComponents')
  .controller("ProfileAdvisorInfoController", ProfileAdvisorInfoController)
  .directive('profileAdvisorInfo', function() {
    return {
      restrict: 'E',
      templateUrl: template,
      controller: "ProfileAdvisorInfoController",
      controllerAs: 'ctrl',
      replace: true,
    }
  });
